import { PagedTableResponse } from '../common/paged-table.model';

export const APPROVAL_RECORD_MODEL_CARD_QUOTA_REQUEST = 'city_parking_client_card_quota_request';
export const APPROVAL_RECORD_MODEL_CARD_QUOTA_ALLOCATION_REQUEST =
  'city_parking_client_card_quota_allocation_request';
export const APPROVAL_RECORD_MODEL_CARD_QUOTA_ALLOCATION = 'city_parking_client_card_quota_allocation';

export interface ApprovalRequestListRow {
  id: number;
  name: string;
  title: string;
  menuName: string;
  recordModel: string;
  recordId: number;
  status: string;
  currentStep: number | null;
  requestUserId: number;
  requesterName: string;
  submittedDate: string | null;
  completedDate: string | null;
  canAct: boolean;
  canForward: boolean;
}

export interface ApprovalRequestTableDto extends PagedTableResponse<ApprovalRequestListRow> {}

export interface ApprovalRequestStep {
  id: number;
  stepNumber: number;
  stepName: string;
  status: string;
  assignedUserId: number | null;
  assignedUserName: string;
  assignedRoleId: number | null;
  assignedRoleName: string;
  assignedDepartmentId: number | null;
  assignedDepartmentName: string;
  forwardedByUserId: number | null;
  forwardedByUserName: string;
  actedByUserId: number | null;
  actedByUserName: string;
  actedDate: string | null;
  remark: string;
}

export interface ForwardCandidate {
  userId: number;
  userName: string;
  roleName: string;
  departmentName: string;
  isDefault: boolean;
}

export interface ApprovalRequestDetail {
  id: number;
  name: string;
  title: string;
  menuListId: number;
  menuName: string;
  recordModel: string;
  recordId: number;
  status: string;
  currentStep: number | null;
  activeLevelCount: number;
  requestRemark: string;
  requestUserId: number;
  requesterName: string;
  submittedDate: string | null;
  completedDate: string | null;
  canAct: boolean;
  canForward: boolean;
  steps: ApprovalRequestStep[];
  forwardCandidates: ForwardCandidate[];
}

export interface ActApprovalStepPayload {
  userId: number;
  remark?: string | null;
}

export interface ForwardApprovalRequestPayload {
  userId: number;
  assignedUserId: number;
  remark?: string | null;
}
